import React from 'react';
import PortfolioPage from '../PortfolioPage';

const ThreeDArtPortfolio = (props) => {
    return (
        <PortfolioPage {...props} id="3D" title={`3D Art Portfolio`} subtitle={'Times I created characters or environments!'} list={'3D art'}/>
    )
}

export default ThreeDArtPortfolio;